import {
  getHandoffSurveyGroupInput,
  getHandoffSurveyGroupOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/get-handoff-survey-group";
import { unaryRpc } from "@redotech/rpc/definition";

// Stateless partner survey-handoff walk: the client sends the accumulated
// answer map each call; nothing is persisted server-side.
export const getHandoffSurveyGroup = unaryRpc({
  name: "getHandoffSurveyGroup",
  input: getHandoffSurveyGroupInput,
  output: getHandoffSurveyGroupOutput,
});
